import * as conditionsSelectors from "./conditions";
import * as entriesSelectors from "./entries";
import * as formSelectors from "./form";
import * as operationsSelectors from "./operations";
import * as sheetsSelectors from "./sheets";
import * as sectionsSelectors from "./sections";
export default {
  ...conditionsSelectors,
  ...entriesSelectors,
  ...formSelectors,
  ...operationsSelectors,
  ...sheetsSelectors,
  ...sectionsSelectors
};